import { createSelector } from '@reduxjs/toolkit';
import { sessionReportSelector } from '@vh/slices/chat/ChatSlice';
import { objectivesSelector } from '@vh/slices/PatientSlice';

export const showableScoreOverviewSelector = createSelector(
  objectivesSelector,
  sessionReportSelector,
  (objectives, sessionReport) => {
    return !!sessionReport || objectives?.length > 0;
  }
);